import React, { useEffect, useState } from 'react';
import { pdfStyles } from '../styles';
import { Text, View } from "@react-pdf/renderer";
import { useStateManager } from 'react-select';

const FifthTable = ({ tableData, uppercaseGrades, headers, practice }) => {

    const [state, setState] = useState(practice)

    const forTable1 = tableData ||
        (state.length && state.map(el => (
            {
                name: el?.title,
                semester: el?.name,
                result: +el?.grade === 4 ? "ХОРОШО" : +el?.grade > 4 ? "ОТЛИЧНО" : +el?.grade === 3 ? "УДОВЛ" : '',
                type: el?.study_place,
                trmid: el.trmid,
            }
        )).sort((a, b) => a.trmid - b.trmid)
            || [{ name: '', participation: '', results: '' }])

    const forTable13 = forTable1 && [headers, ...forTable1]

    // const stylesCheckCell = (num) => num ? [pdfStyles.bold, pdfStyles.center, pdfStyles.centerFlex, pdfStyles.break, pdfStyles.centerVerticallyNew] : pdfStyles.ml3;
    const stylesCheckCell = (num) => num ? [pdfStyles.bold, pdfStyles.center,] : pdfStyles.ml3;
    const stylesCheckNumberCell = (num) => num ? [pdfStyles.bold, pdfStyles.center, pdfStyles.centerFlex] : [pdfStyles.center];
    const stylesCheckRow = (num) => num ? [pdfStyles.tableRow, pdfStyles.bigHeight] : [pdfStyles.tableSmallRow];

    return (
        practice ?

            < View style={[pdfStyles.table]} >
                {
                    // [headers, ...forTable].map((item, index) => (
                    forTable13 && forTable13.map((item, index) => (
                        <View style={stylesCheckRow(item.number)}>
                            <View style={[pdfStyles.tableCol5, pdfStyles.tableCol]}>
                                <Text style={stylesCheckNumberCell(item.number)}>
                                    {item.number ? item.number : index + '.'}
                                </Text>
                            </View>
                            <View style={pdfStyles.tableCol50}>
                                <View style={pdfStyles.tableCol}>
                                    {/* ТАБЛИЦА ИСПОЛЬЗУЕТСЯ В ПРАКТИКАХ(СЕМЕСТР)-НАУЧ-ИССЛ ДЕЯТ-ЛИЧНЫЕ ДОСТ-Я(ДАТА)  */}
                                    <Text style={stylesCheckCell(item.number)}>{item.semester ? `${item.name}, ${item.semester}` : item.name}</Text>
                                </View>

                            </View>
                            {<View style={pdfStyles.tableCol30}>
                                <View style={pdfStyles.tableCol}>
                                    <Text style={stylesCheckCell(item.number)}>{item.type !== null && item.type}</Text>
                                </View>
                            </View>}

                            <View style={[pdfStyles.tableCol20, pdfStyles.center]}>
                                <View style={pdfStyles.tableCol}>
                                    <Text style={stylesCheckCell(item.number)}>{uppercaseGrades ? item.result?.toUpperCase('')?.split().map(item => item) : item.result?.split('').map(item => item)}</Text>
                                </View>
                            </View>
                        </View>
                    ))
                }
            </View >
            :
            <View style={[pdfStyles.table]}>
                {
                    // [headers, ...forTable].map((item, index) => (
                    forTable13 && forTable13.map((item, index) => (
                        <View style={stylesCheckRow(item.number)}>
                            <View style={[pdfStyles.tableCol5, pdfStyles.tableCol]}>
                                <Text style={stylesCheckNumberCell(item.number)}>
                                    {item.number ? item.number : index + '.'}
                                </Text>
                            </View>
                            <View style={pdfStyles.tableCol50}>
                                <View style={pdfStyles.tableCol}>
                                    {/* ТАБЛИЦА ИСПОЛЬЗУЕТСЯ В ПРАКТИКАХ(СЕМЕСТР)-НАУЧ-ИССЛ ДЕЯТ-ЛИЧНЫЕ ДОСТ-Я(ДАТА) //TODO  потом дату еще вкарячить надо */}
                                    <Text style={stylesCheckCell(item.number)}>{item.semester ? `${item.name}, ${item.semester}` : item.name}</Text>
                                </View>

                            </View>
                            <View style={pdfStyles.tableCol30}>
                                <View style={pdfStyles.tableCol}>
                                    <Text style={stylesCheckCell(item.number)}>{item.type !== null && item.type}</Text>
                                </View>
                            </View>

                            <View style={[pdfStyles.tableCol20, pdfStyles.center]}>
                                <View style={pdfStyles.tableCol}>
                                    <Text style={stylesCheckCell(item.number)}>{uppercaseGrades ? item.result?.toUpperCase('')?.split().map(item => item) : item.result?.split('').map(item => item)}</Text>
                                </View>
                            </View>
                        </View>
                    ))
                }
            </View>


    );
};

export default FifthTable;